<app-dialog-wrapper>
  <div class="content">
    <div class="content__message">{{ dialogData['message'] }}</div>
  </div>

  <div footer class="footer">
    <app-button
      [outline]="true"
      [size]="ButtonSize.Large"
      [style]="ButtonStyle.Danger"
      (buttonClick)="closeDialog(false)"
    >
      {{ dialogData['cancelLabel'] || 'No' }}
    </app-button>

    <app-button [size]="ButtonSize.Large" (buttonClick)="closeDialog(true)">
      {{ dialogData['confirmLabel'] || 'Yes' }}
    </app-button>
  </div>
</app-dialog-wrapper>
